<template>

  <v-card v-if="editor">
    <div class="tiptap-editor__toolbar">
    <header class="v-sheet theme--light v-toolbar v-toolbar--dense v-toolbar--flat grey lighten-4">
      <div class="v-toolbar__content" style="min-height: 48px;">
        <div>

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
            h1
          </v-btn>
          
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
            h2
          </v-btn>
          
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
            h3
          </v-btn>
          
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }">
            h4
          </v-btn>

          <!-- <v-btn @click.prevent="editor.chain().focus().toggleHeading({ level: 5 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }">
            h5
          </v-btn>
          <v-btn @click.prevent="editor.chain().focus().toggleHeading({ level: 6 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 6 }) }">
            h6
          </v-btn> -->

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }"
          >
            <v-icon> format_textdirection_l_to_r </v-icon>
          </v-btn>

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
            <v-icon>list</v-icon>
          </v-btn>

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
            <v-icon>format_list_numbered</v-icon>
          </v-btn>
          
          <v-btn type="button" text class="v-btn v-btn--icon v-btn--round theme--light" small 
            @click.prevent="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }"
          >
            <span text class="v-btn__content">
              <b class="">
                <v-icon>format_bold</v-icon>
              </b>
            </span>
          </v-btn>

          <v-btn type="button" text class="v-btn v-btn--icon v-btn--round theme--light" small 
            @click.prevent="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }"
          >
            <span text class="v-btn__content">
              <b class="">
                <v-icon>format_italic</v-icon>
              </b>
            </span>
          </v-btn>

          <v-btn type="button" text class="v-btn v-btn--icon v-btn--round theme--light" small 
            @click.prevent="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }"
          >
            <span text class="v-btn__content">
              <b class="">
                <v-icon>format_underlined</v-icon>
              </b>
            </span>
          </v-btn>

          <v-btn type="button" text class="v-btn v-btn--icon v-btn--round theme--light" small 
            @click.prevent="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }"
          >
            <span text class="v-btn__content">
              <b class="">
                <v-icon>strikethrough_s</v-icon>
              </b>
            </span>
          </v-btn>

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click.prevent="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
            <v-icon> format_quote </v-icon>
          </v-btn>

           <v-btn text class="v-btn v-btn--icon v-btn--round small-button" 
           @click="setLink" :class="{ 'is-active': editor.isActive('link') }">
            <v-icon> insert_link </v-icon>
          </v-btn>

           <!-- <v-btn text class="v-btn v-btn--icon v-btn--round small-button" @click="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')">
            unsetLink
          </v-btn> -->

          <v-btn text class="v-btn v-btn--icon v-btn--round small-button" 
            @click.prevent="editor.chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }"
          >
            <v-icon>code</v-icon>
          </v-btn>

         
          <!-- <v-btn @click.prevent="editor.chain().focus().unsetAllMarks().run()">
            <v-icon> code </v-icon>clear marks
          </v-btn>
          <v-btn @click.prevent="editor.chain().focus().clearNodes().run()">
            <v-icon> code </v-icon>clear nodes
          </v-btn> -->
        

          <!-- <v-btn @click.prevent="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }">
          code block
          </v-btn> -->


          <!-- <v-btn @click.prevent="editor.chain().focus().setHorizontalRule().run()">
            horizontal rule
          </v-btn> 
          <v-btn @click.prevent="editor.chain().focus().setHardBreak().run()">
            hard break
          </v-btn> -->
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().undo().run()">
            <v-icon> undo </v-icon>
          </v-btn>
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().redo().run()">
            <v-icon> redo </v-icon>
          </v-btn>

          <!-- Alignment -->
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().setTextAlign('left').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }">
            <v-icon> format_align_left </v-icon>
          </v-btn>
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().setTextAlign('center').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }">
            <v-icon> format_align_center </v-icon>
          </v-btn>
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().setTextAlign('right').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }">
            <v-icon> format_align_right </v-icon>
          </v-btn>
          <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
           @click.prevent="editor.chain().focus().setTextAlign('justify').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }">
            <v-icon> format_align_justify </v-icon>
          </v-btn>
          <!-- <v-btn @click.prevent="editor.chain().focus().unsetTextAlign().run()">
            unsetTextAlign
          </v-btn> -->

          <!-- Table -->
          <!-- <v-btn text class="v-btn v-btn--icon v-btn--round small-button"
          @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()">
            <v-icon> table_chart </v-icon>
          </v-btn> -->
          <!-- <v-btn @click="editor.chain().focus().addColumnBefore().run()">
            <v-icon> code </v-icon> addColumnBefore
          </v-btn>
          <v-btn @click="editor.chain().focus().addColumnAfter().run()">
            <v-icon> code </v-icon> addColumnAfter
          </v-btn>
          <v-btn @click="editor.chain().focus().deleteColumn().run()">
            <v-icon> code </v-icon> deleteColumn
          </v-btn>
          <v-btn @click="editor.chain().focus().addRowBefore().run()">
            <v-icon> code </v-icon> addRowBefore
          </v-btn>
          <v-btn @click="editor.chain().focus().addRowAfter().run()">
            <v-icon> code </v-icon> addRowAfter
          </v-btn>
          <v-btn @click="editor.chain().focus().deleteRow().run()">
            <v-icon> code </v-icon> deleteRow
          </v-btn>
          <v-btn @click="editor.chain().focus().deleteTable().run()">
            <v-icon> code </v-icon> deleteTable
          </v-btn>
          <v-btn @click="editor.chain().focus().mergeCells().run()">
            <v-icon> code </v-icon> mergeCells
          </v-btn>
          <v-btn @click="editor.chain().focus().splitCell().run()">
            <v-icon> code </v-icon> splitCell
          </v-btn>
          <v-btn @click="editor.chain().focus().toggleHeaderColumn().run()">
            <v-icon> code </v-icon> toggleHeaderColumn
          </v-btn>
          <v-btn @click="editor.chain().focus().toggleHeaderRow().run()">
            <v-icon> code </v-icon> toggleHeaderRow
          </v-btn>
          <v-btn @click="editor.chain().focus().toggleHeaderCell().run()">
            <v-icon> code </v-icon> toggleHeaderCell
          </v-btn>
          <v-btn @click="editor.chain().focus().mergeOrSplit().run()">
            <v-icon> code </v-icon> mergeOrSplit
          </v-btn>
          <v-btn @click="editor.chain().focus().setCellAttribute('colspan', 2).run()">
            <v-icon> code </v-icon> setCellAttribute
          </v-btn>
          <v-btn @click="editor.chain().focus().fixTables().run()">
            <v-icon> code </v-icon> fixTables
          </v-btn>
          <v-btn @click="editor.chain().focus().goToNextCell().run()">
            <v-icon> code </v-icon> goToNextCell
          </v-btn>
          <v-btn @click="editor.chain().focus().goToPreviousCell().run()">
            <v-icon> code </v-icon> goToPreviousCell
          </v-btn> -->
        </div>  
      </div>
    </header>
  </div>
  <div class="tiptap-editor__content pa-6">
    <editor-content :editor="editor" class="ProseMirror"/>
  </div>
  </v-card>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import { Editor, EditorContent } from '@tiptap/vue-2'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
// import Table from '@tiptap/extension-table'
// import TableCell from '@tiptap/extension-table-cell'
// import TableHeader from '@tiptap/extension-table-header'
// import TableRow from '@tiptap/extension-table-row'
export default {
  components: {
    EditorContent
  },
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      editor: null,
    }
  },
  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit.configure({
          // Disable an included extension
          // history: false,

          // Configure an included extension
          heading: {
            levels: [1, 2, 3, 4],
            HTMLAttributes: {
              class: 'header-class',
            },
          },
        }),
        Underline,
        Link.configure({
          // HTMLAttributes: {
          //   class: 'mail-button mail-button-primary',
          // },
          protocols: ['ftp', 'mailto'],
          openOnClick: true,
          linkOnPaste: true,
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
          alignments: ['left', 'right', 'center', 'justify'],
        }),
        // Table.configure({
        //   resizable: true,
        // }),
        // TableRow,
        // TableHeader,
        // TableCell,
      ],
      content: this.value,
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())
      },
    })
  },
  emits: ['update:modelValue'],

  methods: {
    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()

        return
      }

      //check if link is a button
      if (/Button/.test(url)) {
        // update link
          this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: url })
            .run()

      }
      else{
          // update link
          this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: url })
            .run()
      }

      
    },
      

  },


  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>


<style lang="scss">
/* Basic editor styles */
.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  .is-active{
    background: #0D0D0D;
    color: #FFF;
  }

  pre {
    background: #0D0D0D;
    color: #FFF;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0D0D0D, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0D0D0D, 0.1);
    margin: 2rem 0;
  }

  img {
    max-width: 100%;
    height: auto;

    &.ProseMirror-selectednode {
      outline: 3px solid #68CEF8;
    }
  }

  .tableWrapper {
    padding: 1rem 0;
    overflow-x: auto;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

 
}

.v-btn{
  margin-left: -4px;
  border: none;
}

.v-btn--contained{
  -webkit-box-shadow:none;
  box-shadow:none;
}

.button{
  -webkit-box-align:center;
  align-items: center;
    color: inherit;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    -webkit-box-pack: inherit;
    -ms-flex-pack: inherit;
    justify-content: inherit;
    line-height: normal;
    position: relative;
    -webkit-transition: inherit;
    transition: inherit;
    transition-property: opacity;
}

.small-button{
  height: 35px !important;
  width: 35px !important;
}

[contenteditable] {
  outline: 0px solid transparent;
  min-height: 100px;
}
</style>